export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref14969.a1ec0909.jpg";